import { GridRenderCellParams } from '@mui/x-data-grid';

import { TagsDisplay } from 'shared/base';

export const TagsColumn = ({ value }: GridRenderCellParams<any, Record<string, string>>) => {
  return <TagsDisplay tags={value ?? {}} />;
};
